import gql from 'graphql-tag'

export const thingTypeUpdateAdmin = gql`
  mutation thingTypeUpdateAdmin($name: String!, $thingTypeFamilyId: ID!) {
    thingTypeUpdateAdmin(input: { name: $name, thingTypeFamilyId: $thingTypeFamilyId }) {
      success
    }
  }
`
